import React from 'react';
import EditableText from './EditableText';
import ColorPalette from './ColorPalette';

function Details({ details, setDetails, subtitle, setSubtitle }) {
  const updateLine = (section, index, value) => {
    const updated = { ...details };
    updated[section].lines[index] = value;
    setDetails(updated);
  };

  const updateTitle = (section, value) => {
    const updated = { ...details };
    updated[section].title = value;
    setDetails(updated);
  };

  return (
    <section className="section" id="details">
      <h2 className="section-title">Details</h2>
      <EditableText value={subtitle} onChange={setSubtitle} tag="div" className="section-subtitle" html={true} />
      <div className="details-grid">
        <div className="detail-item">
          <EditableText value={details.when.title} onChange={val => updateTitle('when', val)} tag="h3" html={true} />
          {details.when.lines.map((line, index) => (
            <EditableText key={index} value={line} onChange={val => updateLine('when', index, val)} tag="p" html={true} />
          ))}
        </div>
        <div className="detail-item">
          <EditableText value={details.where.title} onChange={val => updateTitle('where', val)} tag="h3" html={true} />
          {details.where.lines.map((line, index) => (
            <EditableText key={index} value={line} onChange={val => updateLine('where', index, val)} tag="p" html={true} />
          ))}
        </div>
        <div className="detail-item">
          <EditableText value={details.dressCode.title} onChange={val => updateTitle('dressCode', val)} tag="h3" html={true} />
          {details.dressCode.lines.map((line, index) => (
            <EditableText key={index} value={line} onChange={val => updateLine('dressCode', index, val)} tag="p" html={true} />
          ))}
        </div>
        <div className="detail-item">
          <ColorPalette />
        </div>
      </div>
    </section>
  );
}

export default Details;
